var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stat-card',{attrs:{"label":"Participations","loading":_vm.loading,"stat":_vm.results.length,"color-class":"bg-green-500","neutralBadge":_vm.year > 0 ? _vm.year : ''}},[_c('calendar-icon',{staticClass:"w-6 h-6 text-white"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }